import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/homeData";

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20editorial%20product%20photography%20of%20a%20diverse%20collection%20of%20fashion%20and%20lifestyle%20goods%20including%20sneakers%20hoodies%20caps%20bags%20and%20accessories%20artfully%20scattered%20across%20a%20warm%20cream%20textured%20surface%20with%20soft%20diffused%20overhead%20lighting%2C%20magazine%20quality%20flatlay%2C%20rich%20neutral%20earthy%20tones%2C%20high%20detail%20textures%2C%20elegant%20organic%20arrangement%2C%20professional%20commercial%20photography&width=1920&height=1080&seq=hero-bg-v2-mulebuy-01&orientation=landscape"
          alt="Mulebuy spreadsheet verified product sourcing directory"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-10" ref={dropdownRef}>
            <div className="relative inline-block">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800 font-medium text-sm hover:bg-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                Browse Product Categories
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full mt-3 left-1/2 -translate-x-1/2 w-72 bg-background-50 rounded-2xl border border-background-200/70 py-3 max-h-96 overflow-y-auto text-left shadow-sm">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-900 transition-colors cursor-pointer"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span className="w-7 h-7 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                        <i className={`${cat.icon} text-accent-600 text-sm`}></i>
                      </span>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 leading-tight mb-6">
            The #1 Mulebuy Spreadsheet Database
            <br />
            <span className="text-background-50/80 font-normal text-2xl md:text-4xl lg:text-5xl">
              for Verified Product Lists
            </span>
          </h1>

          <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover the most updated and trusted <strong>mulebuy spreadsheet</strong> collections, including electronics,
            fashion, shoes, and trending product sourcing lists — updated daily.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Mulebuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50 text-foreground-900 font-semibold text-base hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Buy It Now
            </a>
            <Link
              to="/mulebuy-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border border-background-50/40 text-background-50 font-medium text-base hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Read SEO Guide
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="text-background-50/50 text-xs">Scroll to explore</span>
        <i className="ri-arrow-down-line text-background-50/50 animate-bounce"></i>
      </div>
    </section>
  );
}